import React from "react";
import {StarFilled, StarOutlined} from "@ant-design/icons";


export default function StaredField(props) {
    var isStared = !!props.value

    return (
        <div style={{cursor: "pointer", color: "#fabc10", fontSize: 20,border:"0px solid black"}}
             onClick={() => props.onChange(!isStared)}>
            {isStared && <StarFilled/>}
            {!isStared && <StarOutlined/>}
        </div>
    )
}
